import type { TocItem } from '../../lib/blog/types'

/** On-page table of contents built from h2/h3 headings. */
export default function TableOfContents({ items }: { items: TocItem[] }) {
  if (!items.length) return null
  return (
    <nav aria-label="Table of contents" className="rounded-2xl bg-surface-muted/60 p-5 text-[0.9rem]">
      <p className="font-semibold text-ink mb-3">On this page</p>
      <ul className="space-y-2">
        {items.map((it) => (
          <li key={it.id} className={it.level === 3 ? 'pl-4' : ''}>
            <a href={`#${it.id}`} className="text-ink-soft hover:text-ink transition">
              {it.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  )
}
